import { fnAuto } from '../../core/formatter/formatNumber';
import { getSystemparameter } from '../../main/functions/getSystemparameter';
import { i18n } from '../../i18n/i18n';
import { Kennzahl } from '../../main/functions/strukturiert/Kennzahl';
import { Md5 } from 'ts-md5/dist/md5';
import * as Moment from 'moment';
import { parseValue } from '../../main/functions/strukturiert/Kennzahl';
import * as React from 'react';
import { transformUnit } from './elements/KennzahlenInfo';

interface DatenauswertungKennzahlenRendererProps extends React.ClassAttributes<any> {
    data: any;
    kennzahlen: any[];
    isTooltip?: boolean;
}

interface DatenauswertungKennzahlenRendererState {
    showFolder: any;
    showAll: boolean;
    showDetailed: boolean;
}

const maxDeciLength = 8;
export class DatenauswertungKennzahlenRenderer extends React.Component<DatenauswertungKennzahlenRendererProps, DatenauswertungKennzahlenRendererState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showAll: false,
            showFolder: {},
            showDetailed: false
        };

        this.getFaktorenFields = this.getFaktorenFields.bind(this);
        this.getItemFields = this.getItemFields.bind(this);
        this.getKennzahlFields = this.getKennzahlFields.bind(this);

        this.defaultShowLevel = getSystemparameter(this.props.data, 'kennzahlen_renderer_default_show_level') || 3;
    }

    private renderLevel = 0;
    private defaultShowLevel = 3;

    render(): JSX.Element {
        return <>
            {!this.props.isTooltip && this.renderFuncButtons()}
            {this.renderKennzahlenCascaded()}
        </>;
    }

    renderFuncButtons(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', padding: 10, fontSize: 12 }}>
                <label>
                    <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center' }}>
                        <input
                            type='checkbox'
                            checked={this.state.showAll}
                            onChange={(event: any) => {
                                const showAll = event.target.checked;
                                this.setState({ showAll }, () => this.toggleShowFolder(showAll));
                            }}
                        />
                        <span>{i18n('Alle ausklappen', 'sys')}</span>
                    </div>
                </label>
                <label>
                    <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center', marginLeft: 20 }}>
                        <input
                            type='checkbox'
                            checked={this.state.showDetailed}
                            onChange={(event: any) => {
                                const showDetailed = event.target.checked;
                                this.setState({ showDetailed });
                            }}
                        />
                        <span>{i18n('Detail-Felder anzeigen', 'sys')}</span>
                    </div>
                </label>
            </div>
        );
    }

    toggleShowFolder(show: boolean) {
        const showFolder = this.state.showFolder;
        Object.keys(showFolder).forEach((k: string) => showFolder[k] = show);
        this.setState({ showFolder });
    }

    renderKennzahlenCascaded(): JSX.Element {
        const { kennzahlen } = this.props;
        this.renderLevel = 0;
        return (
            <div style={{ fontSize: 12, flex: 1, overflowY: 'auto' }}>
                {this.renderListRecursive(kennzahlen, this.getKennzahlFields())}
            </div>
        );
    }

    renderListRecursive(rows: any[], fields: any[], config?: any): JSX.Element {
        const { showFolder, showDetailed } = this.state;
        const isTooltip: boolean = !!this.props.isTooltip;
        if (!showDetailed) {
            // Die technischen Keys nicht anzeigen
            fields = fields.filter((f: any) => ['kennzahl_key', 'key', 'field'].indexOf(f.key) === -1);
        }
        if (isTooltip) {
            fields = fields.filter((f: any) => ['value', 'items'].indexOf(f.key) !== -1);
        }
        if (Array.isArray(rows)) {
            this.renderLevel++;
            const list = <ul style={{ listStyleType: 'none', ...(isTooltip && this.renderLevel === 1 ? { margin: 0, padding: 0 } : { paddingLeft: 10 }) }}>
                {rows.map((r: any, i: number) => {
                    if (isTooltip && ((this.renderLevel > 3) || (this.renderLevel === 3 && typeof r.valueOrig === 'undefined'))) {
                        return null;
                    }
                    const type: string = parseValue(r.type) || null;
                    let style: React.CSSProperties = !isTooltip
                        ? {
                            border: '1px solid black', padding: 10, marginTop: 0, marginBottom: 3, borderRadius: 10,
                            width: 'fit-content', backgroundColor: this.getBGColor(this.renderLevel),
                            ...(config && config.backgroundColor ? { backgroundColor: config.backgroundColor } : {})
                        }
                        : {};
                    return <li key={`li_${i}`}>
                        <div key={`li_div_${i}`} style={style}>
                            {fields.map((f: any, j: number) => {
                                const rowStyle: React.CSSProperties = { display: 'flex', flexDirection: 'row' };
                                const headerStyle: React.CSSProperties = isTooltip
                                    ? { fontWeight: 'bold', marginRight: 10 }
                                    : { fontWeight: 'bold', width: 80, minWidth: 80, marginRight: 10 };
                                // const isFolder = f.isFolder ? true : false;
                                const isFolder = Array.isArray(r[f.key]) && r[f.key].length > 0 ? true : false;
                                const folderKey = isFolder ? this.getFolderKey([i, j, r[f.key]]) : null;
                                if (folderKey && showFolder[folderKey] === undefined) {
                                    showFolder[folderKey] = this.renderLevel < this.defaultShowLevel;
                                    // this.setState({ showFolder }); // unnötig 
                                }
                                const showValue = this.renderValue(r, f);
                                return <div key={`li_div_field_${j}`}>
                                    {typeof f.getChildFields === 'function'
                                        ? isFolder
                                            ? <>{isTooltip && f.key === 'items' && this.renderLevel === 1 &&
                                                <div style={rowStyle}>
                                                    <div style={headerStyle}>
                                                        {i18n(((this.props.kennzahlen || [])[0].items || []).length > 1? 'Werte' : 'Wert', 'sys')}:
                                                    </div>
                                                </div>
                                            }
                                                <div style={rowStyle}>
                                                    {!isTooltip &&
                                                        <div style={headerStyle}>{f.name}</div>
                                                    }
                                                    {this.state.showFolder[folderKey] === true
                                                        ? <div style={rowStyle}>
                                                            {!isTooltip && <div
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    const showFolder = this.state.showFolder;
                                                                    showFolder[folderKey] = false;
                                                                    this.setState({ showFolder });
                                                                }}
                                                            >
                                                                {String.fromCharCode(9660)}
                                                            </div>}
                                                            <div style={{ maxHeight: 600, overflowY: 'auto' }}>
                                                                {this.renderListRecursive(r[f.key], f.getChildFields(), f)}
                                                            </div>
                                                        </div>
                                                        : <div style={rowStyle}>
                                                            {!isTooltip && <div
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    const showFolder = this.state.showFolder;
                                                                    showFolder[folderKey] = true;
                                                                    this.setState({ showFolder });
                                                                }}
                                                            >
                                                                {String.fromCharCode(9654)}
                                                            </div>}
                                                            <div style={{ fontStyle: 'italic', marginLeft: 5 }}>
                                                                {`${r[f.key].length} ${i18n(r[f.key].length > 1 ? 'Datensätze' : 'Datensatz', 'sys')}`}
                                                            </div>
                                                        </div>
                                                    }
                                                </div></>
                                            : null
                                        : (r[f.key] || r[f.key] === 0) && !(f.hideNull && !showValue)
                                            ? <div style={rowStyle}>
                                                {!isTooltip && f.name &&
                                                    <div style={headerStyle}>{f.name}</div>
                                                }
                                                {isTooltip && f.key === 'value' && this.renderLevel === 1 &&
                                                    <div style={{ whiteSpace: 'nowrap' }}><b>{i18n('Wert', 'sys')}{type && ` (${i18n(type, 'sys')})`}:&nbsp;</b></div>
                                                }
                                                {isTooltip && this.renderLevel > 1 &&
                                                    <b style={{ ...(this.renderLevel > 2 && { lineHeight: 1 }) }}>
                                                        {String.fromCharCode(this.renderLevel > 2 ? 9675 : 8226)}&nbsp;
                                                    </b>
                                                }
                                                <div style={{ maxWidth: 400 }}>{showValue}</div>
                                            </div>
                                            : null
                                    }
                                </div>;
                            })}
                        </div>
                    </li>
                })}
            </ul>;
            this.renderLevel--;
            return list;
        }
        return null;
    }

    renderValue(row: any, field: any) {
        let value = row[field.key];
        if (typeof value === 'number') {
            value = fnAuto(value, maxDeciLength);
        } else if (typeof value === 'string') {
            if (typeof field.parseValue === 'function') {
                value = field.parseValue(value);
            }
        } else {
            value = JSON.stringify(value);
        }
        if (typeof field.render === 'function') {
            return field.render(value, row, field);
        }
        return value;
    }

    getKennzahlFields() {
        const fields: any[] = [
            ...[{ key: 'kennzahl_key', name: i18n('Kennzahl', 'sys') }],
            ...this.getItemFields()
        ];
        return fields;
    }

    getItemFields(isChild = false) {
        const fields: any[] = [
            { key: 'key', name: i18n('Key', 'sys') },
            { key: 'field', name: i18n('Feld', 'sys') },
            { key: 'name', name: i18n('Bezeichnung', 'sys') },
            { key: 'type', name: i18n('Typ', 'sys'), parseValue },
            ...(isChild ? [] : [{ key: 'bereich', name: i18n('Bereich', 'sys'), parseValue }]),
            {
                key: 'datum_von', name: i18n('Zeitraum', 'sys'), hideNull: true,
                render: (value: number, row: any, field: any) => {
                    if (Array.isArray(row.items) && row.items.length > 0) {
                        return null;
                    }
                    const datum_von = row.datum_von > 0 ? Moment.unix(row.datum_von).format('DD.MM.YYYY') : null;
                    const datum_bis = row.datum_bis > 0 ? Moment.unix(row.datum_bis).format('DD.MM.YYYY') : null;
                    if (!datum_von && !datum_bis) {
                        return null;
                    }
                    return `${datum_von || ''} - ${datum_bis || ''}`;
                }
            },
            { key: 'formel', name: i18n('Formel', 'sys') },
            {
                key: 'value', name: i18n('Wert', 'sys'),
                render: (value: number | string, row: any, field: any) => getKennzahlFormel(row)
            },
            {
                key: 'valueOrig', name: 'Wert (orig.)',
                render: (value: number | string, row: any, field: any) => {
                    return `${value}${row.einheitOrig ? ` ${transformUnit(row.einheitOrig)}` : ''}`;
                }
            },
            { key: 'info', name: i18n('Info', 'sys') },
            { key: 'faktoren', name: i18n('Faktoren', 'sys'), getChildFields: this.getFaktorenFields }, // backgroundColor: '#cfc',
            { key: 'items', name: i18n('Teilwerte', 'sys'), getChildFields: () => this.getItemFields(true) }
        ];
        return fields;
    }

    getFaktorenFields() {
        const fields: any[] = [
            { key: 'info', name: i18n('Bezeichnung', 'sys') },
            { key: 'quelle', name: i18n('Quelle', 'sys') },
            { key: 'type', name: i18n('Typ', 'sys'), parseValue },
            {
                key: 'tage', name: i18n('Tage', 'sys'),
                render: (value: number | string) => value
            },
            {
                key: 'tageOrig', name: `${i18n('Tage', 'sys')} (orig.)`,
                render: (value: number | string) => value
            },
            {
                key: 'gtz', name: i18n('GTZ', 'sys'),
                render: (value: number | string) => value
            },
            {
                key: 'gtzOrig', name: `${i18n('GTZ', 'sys')} (orig.)`,
                render: (value: number | string) => value
            },
            {
                key: 'value', name: i18n('Wert', 'sys'),
                render: (value: number | string, row: any, field: any) => {
                    return `${value}${row.einheit ? ` ${transformUnit(row.einheit)}` : (row.type === 'type_co2' ? ' tCO₂Äq/kWh' : '')}`;
                }
            }
        ];
        return fields;
    }

    getFolderKey(data: any) {
        const key = Md5.hashAsciiStr(JSON.stringify(data)).toString();
        return key;
    }

    getBGColor(idx: number) {
        const bgColor = ['#fff', '#fff', '#eee', '#ddd', '#ccc', '#bbb', '#aaa'];
        return bgColor[idx] || '#aaa';
    }
}

export function getKennzahlFormel(kennzahl: any) {
    // console.log(kennzahl);
    let wert = `${fnAuto(kennzahl.value || 0, maxDeciLength)}${kennzahl.einheit ? ` ${transformUnit(kennzahl.einheit)}` : ''}`;
    if (kennzahl.type === Kennzahl.TYPE_EINGABE) {
        if (kennzahl.valueOrig && Array.isArray(kennzahl.faktoren) && kennzahl.faktoren.length > 0) {
            wert = `${wert} = ${getKennzahlFormelEingabe(kennzahl)}`;
        }
    } else if (kennzahl.type === Kennzahl.TYPE_SUMME) {
        if (Array.isArray(kennzahl.items) && kennzahl.items.length > 1) {
            wert = `${wert} = ${getKennzahlFormelSumme(kennzahl)}`;
        }
    } else if (kennzahl.type === Kennzahl.TYPE_BERECHNUNG) {
        if (Array.isArray(kennzahl.items) && (kennzahl.items.length > 1 || (Array.isArray(kennzahl.faktoren) && kennzahl.faktoren.length > 0))) {
            wert = `${wert} = ${getKennzahlFormelBerechnung(kennzahl)}`;
        }
    } else if (kennzahl.type === Kennzahl.TYPE_MAX) {
        if (Array.isArray(kennzahl.items) && kennzahl.items.length > 0) {
            wert = `${wert} = ${getKennzahlFormelMax(kennzahl)}`;
        }
    }
    return wert;
}

export function getKennzahlFormelSumme(kennzahl: any) {
    const items = kennzahl.items || [];
    return items.map((i: any) => `${fnAuto(i.value || 0, maxDeciLength)}${i.einheit ? ` ${transformUnit(i.einheit)}` : ''}`).join(' + ');
}

export function getKennzahlFormelBerechnung(kennzahl: any) {
    const items = kennzahl.items || [];
    const faktoren = kennzahl.faktoren || [];
    return items.map((i: any, idx: number) => `${fnAuto(i.value || 0, maxDeciLength)}${i.einheit ? ` ${transformUnit(i.einheit)}` : ''}${faktoren[idx] ? ` × ${fnAuto(faktoren[idx].value || 0, maxDeciLength)} ${faktoren[idx].einheit ? ` ${transformUnit(faktoren[idx].einheit)}` : (faktoren[idx].type === 'type_co2' ? ' tCO₂Äq/kWh' : '')}` : ''}`).join(' + ');
}

export function getKennzahlFormelEingabe(kennzahl: any) {
    const faktoren = kennzahl.faktoren || [];
    return [
        `${fnAuto(kennzahl.valueOrig || 0, maxDeciLength)}${kennzahl.einheitOrig ? ` ${transformUnit(kennzahl.einheitOrig)}` : ''}`,
        ...faktoren.map((f: any) => `${fnAuto(f.value || 0, maxDeciLength)} ${f.einheit ? ` ${transformUnit(f.einheit)}` : (f.type === 'type_co2' ? ' tCO₂Äq/kWh' : '')}`)
    ].join(' × ');
}

export function getKennzahlFormelMax(kennzahl: any) {
    const items = kennzahl.items || [];
    return 'MAX(' + items.filter((i: any) => i.value).map((i: any) => `${fnAuto(i.value || 0, maxDeciLength)}${i.einheit ? ` ${transformUnit(i.einheit)}` : ''}`).join(', ') + ')';
}
